<template lang="html">
  <div>
    <b-modal
      id="modal-1"
      title="Työtehtävä"
      @ok="tasks_sumbit"
    >
      <label>
        Anna työn kuvas tai valitse tehtävistä:
      </label>
      <form @submit="form_submit">
        <b-form-select
         v-if="todos.length > 0"
          v-model="task_title"
          :options="todos"
          class="mb-3"
          value-field="title"
          text-field="title"
        >
        <template v-slot:first>
          <option value="">-- Valitse --</option>
        </template>
        </b-form-select>
        <b-form-input v-model="task_title" placeholder="Kirjoita työtehtävä jos se ei löydy listasta" required></b-form-input>
      </form>
    </b-modal>

    <b-modal
      id="modal-2"
      title="Tehdyt tunnit"
      hide-footer
      scrollable
    >
        <ul id="v-for-object" class="demo" v-for="task_day in old_work_done.slice().reverse()" :key="task_day.title">
          <b-list-group-item >
            <b>{{task_day.title}}</b>
            <br><h5>Työtehtävät:</h5>
            <li v-for="(value, item) in task_day.tasks" :key="value">
              {{item}}: {{ format_ms(value)}}
            </li>
            <b>Tunnit yhteensä: </b>{{task_day.duration}}
          </b-list-group-item>
        </ul>
        <b-button size="sm" class="mt-3" block @click="$bvModal.hide('modal-2')">Sulje</b-button>
    </b-modal>
    <b-modal
      id="modal-3"
      title="Muuta linkin osoitetta"
      hide-footer
    >
    <b-form @submit.prevent="change_link_modal" inline>
          <label>Linkki(muodossa https://www.xxxxxx.xx)</label>
          <b-form-input v-model = "modal_link" class="w-100" type="text" placeholder="Työpaikan työkirjaussivun linkki"/>
    </b-form>
        <b-button size="sm" variant="info" class="mt-3" block @click="$bvModal.hide('modal-3');change_link_modal()">ok</b-button>
    </b-modal>

    <b-modal
      id="modal-4"
      title="Päivitä töihin tuloaika"
      hide-footer
    >
        <label>Työpäivä alkoi: </label><br>
        <vue-timepicker v-model = "new_start_time"></vue-timepicker>
        <div>
        <b-button size="sm" variant="info" class="mt-3" block @click="$bvModal.hide('modal-4');update_start_time()">ok</b-button>
      </div>
    </b-modal>
    <b-modal
      id="modal-fix_timetask"
      title="Työtehtävä"
      @ok="update_timertask"
    >
      <label>
        Anna työn kuvas tai valitse tehtävistä:
      </label>
      <form @submit="update_timertask">
        <b-form-select
         v-if="todos.length > 0"
          v-model="task_title"
          :options="todos"
          class="mb-3"
          value-field="title"
          text-field="title"
        >
        <template v-slot:first>
          <option value="">-- Valitse --</option>
        </template>
        </b-form-select>
        <b-form-input v-model="task_title" :placeholder="selected.task.title" required></b-form-input>
      </form>
      <b-button class="mt-3" block variant="outline-danger" v-b-modal.up_or_down v-if="selected.id > 0 && selected.id != (task_i - 1)">Poista tehtävä</b-button>
      <b-button class="mt-3" block variant="outline-danger" @click="remove_task_next" v-if="selected.id == 0 && task_i > 1">Poista tehtävä</b-button>
    </b-modal>
    <b-modal
      id="up_or_down"
      title="mihin lisätään"
      hide-footer
    >
      <b-button class="mt-3" block @click="remove_task_pre">Lisää tehtävän aika edelliseen tehtävään</b-button>
      <b-button class="mt-3" block @click="remove_task_next">Lisää tehtävän aika seuraavaan tehtävään</b-button>
    </b-modal>

  </div>
</template>

<script>
import moment from 'moment';
import VueTimepicker from 'vue2-timepicker';


export default {
  props:["todos", "old_work_done", "link","selected", "task_i"],
  data(){
    return {
      task_title:"",
      modal_link:"",
      new_start_time:"",
    }
  },
  components: { VueTimepicker },
  methods: {
    tasks_sumbit(){
      this.$bvModal.hide('modal-1');
      this.$emit("add_timer_list", this.task_title);
      this.task_title = "";
    },
    form_submit(e){
      e.preventDefault();
      this.tasks_sumbit();

    },
    format_ms(time) {
       return moment.utc(time).format('HH:mm');
     },
     change_link_modal(){
       this.$bvModal.hide('modal-3');
       this.$emit("change_link", this.modal_link);
     },
     update_start_time(){
       this.$emit("update_start_time", this.new_start_time);
     },
     remove_task_pre(){
       this.$bvModal.hide('modal-fix_timetask');
       this.$bvModal.hide('up_or_down');
       this.$emit("remove_this_task", -1);
     },
     remove_task_next(){
       this.$bvModal.hide('modal-fix_timetask');
       this.$bvModal.hide('up_or_down');
       this.$emit("remove_this_task", 1);
     },
     update_timertask(){
       let index = this.todos.findIndex(item => item.title == this.task_title);
       if(index + 1){
         this.selected.task = this.todos[index];
       }
       else{
         this.selected.task = {title:this.task_title};
       }
     }
  },
  mounted(){
    this.modal_link = this.link;
  }

}
</script>

<style lang="css" scoped>
</style>
